<div class="shareFleetInviteSectionEmailInputWrapper">
  <pp-share-edit-email-input
    class="shareFleetInviteSectionEmailInput"
    [(ppEmailList)]="ppEmailList"
    (ppEmailListChange)="updateEmails($event)"
  ></pp-share-edit-email-input>

  <button
    [class.shareFleetInviteSectionEmailButton--disabled]="ppDisabled"
    class="shareFleetInviteSectionEmailButton"
    (click)="inviteUsers()"
    >
    @if (ppProcessing) {
      <pp-spinner></pp-spinner>
    }
    @if (!ppProcessing) {
      <span>
        {{ 'invite' | ppTranslate }}
      </span>
    }
  </button>
</div>
